import pvi_deflection from "../../img/info/pvi_deflection.jpg";
import "./Information.css";

const PVIDeflectionPage = () => {
    return (
      <div className="info_container">
        <h1>Pavement Vehicle Interaction (PVI)-Deflection</h1>
        <h2>Overview</h2>
        <p>Pavement Vehicle Interaction (PVI) involves the complex interplay between a vehicle’s tires and the pavement surface. One of the critical aspects of PVI is pavement deflection, which refers to the bending or flexing of the pavement surface under the load of moving vehicles. This page provides an overview of how pavement deflection affects vehicle fuel consumption and associated greenhouse gas (GHG) emissions throughout the pavement's life cycle, emphasizing its importance in pavement life cycle assessments (LCA). </p>
        <figure className="figure">
            <img src={pvi_deflection} alt="PVI Deflection" />
            <figcaption>Figure 1 Pavement surface deflection and Pavement Vehicle Interaction (PVI) [1]</figcaption>
        </figure>
        <h2>Pavement Deflection</h2>
        <p>Pavement deflection occurs when a vehicle's weight causes the pavement surface to flex downward. The degree of deflection is influenced by factors such as pavement material, structural design, and underlying soil conditions. Flexible (asphalt) pavements typically exhibit more deflection compared to rigid (concrete) pavements.</p>
        <h2>Impact on Fuel Consumption and GHG Emissions</h2>
        <p>When a pavement deflects, the vehicle tires must overcome additional resistance, increasing the rolling resistance. This added resistance requires more energy from the vehicle, leading to higher fuel consumption and increased GHG emissions. Key impacts include:</p>
        <ul>
        <li><b>Increased Fuel Consumption:</b> More energy is needed to maintain vehicle speed over deflected pavements, leading to higher fuel usage.</li>
        <li><b>Elevated GHG Emissions:</b> Increased fuel consumption results in higher emissions of CO2 and other GHGs, underscoring the environmental impact of pavement deflection.</li>
        </ul>
        <h2>Referencs</h2>
        <div className="info_ref-block">
          <p>MIT CSHub, "Lowering Vehicle Fuel Consumption and Emissions Through Better Pavement Design and Maintenance," MIT CSHub, Cambridge, 2016.</p>
        </div>
      </div>
    );
  }
  
  export default PVIDeflectionPage;